module.exports = __webpack_public_path__ + "resources/img/ico-company-certification-l@2x.60707814.png";